import { SiteSettingsState } from '../types';

export const siteSettings = (state: any): SiteSettingsState =>
  state.siteSettings;
